import {InvalidTokenError} from '@packages/utils';
import {parseCookies} from 'nookies';
import {useCallback, useEffect, useState} from 'react';
import {
  followCommunityTopic,
  unFollowCommunityTopic,
} from '../repositories/communityRepository';
import {useIsSessionExpired} from './auth/useIsSessionExpired';

type Props = {
  topicId: number;
  followCountInitial: number;
  isFollowedInitial: boolean;
};

export function useHandleFollowingCommunityTopic({
  topicId,
  followCountInitial,
  isFollowedInitial,
}: Props) {
  const cookies = parseCookies();
  const {updateIsSessionExpired} = useIsSessionExpired();
  const [followCount, setFollowCount] = useState<number>(followCountInitial);
  const [isFollowed, setIsFollowed] = useState<boolean>(isFollowedInitial);

  useEffect(() => {
    setFollowCount(followCountInitial);
    setIsFollowed(isFollowedInitial);
  }, [topicId]);

  const unFollowUsecase = useCallback(
    async function unFollowUsecase() {
      const deleteData = await unFollowCommunityTopic({
        cookies,
        topicId,
      });

      if (!deleteData.ok && deleteData.error === InvalidTokenError) {
        updateIsSessionExpired(true);
      }

      if (!deleteData.ok) {
        return;
      }

      setIsFollowed(false);
      setFollowCount(deleteData.value.followerCount);
    },
    [topicId, cookies],
  );

  const followUsecase = useCallback(
    async function followUsecase() {
      const updateData = await followCommunityTopic({
        cookies,
        topicId,
      });

      if (!updateData.ok && updateData.error === InvalidTokenError) {
        updateIsSessionExpired(true);
      }

      if (!updateData.ok) {
        return;
      }

      setIsFollowed(true);
      setFollowCount(updateData.value.followerCount);
    },
    [topicId, cookies],
  );

  const handleFollowingCommunityTopic = useCallback(async () => {
    if (isFollowed) {
      await unFollowUsecase();
      return;
    }

    await followUsecase();
  }, [isFollowed, unFollowUsecase, followUsecase]);

  return {handleFollowingCommunityTopic, followCount, isFollowed};
}
